import { preloadCustomComponentsClient } from '../../preloadCustomComponentsClient';

export const onBeforeRenderClient = preloadCustomComponentsClient;
